const WEEKDAYS = {Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 7};

export function weekdayNumber(date, timeZone) {
  return WEEKDAYS[new Intl.DateTimeFormat('en-US', {weekday: 'short', timeZone}).format(date)];
}

export function chooseSpecial(cards, weekday) {
  return cards.find(card => Number(card.dataset.specialDay) === weekday) || cards[0] || null;
}

export function publishSpecialClick(shopify, card) {
  try {
    if (shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true || typeof shopify?.analytics?.publish !== 'function') return;
    const published = shopify.analytics.publish('tnm:daily_special_clicked', {
      placement: 'homepage_daily_special',
      weekday: card.dataset.specialDay,
      product_id: card.dataset.productId,
      variant_id: card.dataset.variantId,
      product_handle: card.dataset.productHandle,
      price_cents: Number(card.dataset.priceCents),
      currency: card.dataset.currency,
    });
    Promise.resolve(published).catch(() => console.warn('Daily special measurement is unavailable.'));
  } catch {
    console.warn('Daily special measurement is unavailable.');
  }
}

function initialize(root) {
  if (root.dataset.rotationReady === 'true') return;
  root.dataset.rotationReady = 'true';
  const cards = Array.from(root.querySelectorAll('[data-special-day]'));
  let current = null;
  function refresh() {
    try {
      const now = new Date();
      const weekday = weekdayNumber(now, root.dataset.timeZone);
      const selected = chooseSpecial(cards, weekday);
      if (!selected) return;
      cards.forEach(card => { card.hidden = card !== selected; });
      selected.querySelector('[data-special-label]').textContent = "TODAY'S SPECIAL";
      selected.querySelector('[data-special-day-label]').textContent = new Intl.DateTimeFormat('en-US', {weekday: 'long', timeZone: root.dataset.timeZone}).format(now).toUpperCase();
      root.dataset.activeDay = String(weekday);
      root.dataset.activeProduct = selected.dataset.productHandle;
      current = selected;
    } catch {
      // Keep the working weekly offer and link if the time zone cannot be resolved.
      console.warn('Daily special rotation is unavailable; showing the weekly offer.');
    }
  }
  refresh();
  root.addEventListener('click', event => {
    const link = event.target.closest('[data-special-cta]');
    if (link && current && current.contains(link)) publishSpecialClick(window.Shopify, current);
  });
  const timer = window.setInterval(() => {
    if (!root.isConnected) { window.clearInterval(timer); return; }
    if (!document.hidden) refresh();
  }, 30000);
  document.addEventListener('visibilitychange', () => { if (!document.hidden && root.isConnected) refresh(); });
}

if (typeof document !== 'undefined') {
  const boot = () => document.querySelectorAll('[data-daily-specials]').forEach(initialize);
  boot();
  document.addEventListener('shopify:section:load', boot);
}
